// Payroll Detail Mutations

export const updatePayrollDetailList = (state, payload) => {
  state.payrollDetailList = payload
}

export const fetchPayrollDetailInfo = (state, payload) => {
  state.payrollDetailInfo = payload
}
